module.exports = __webpack_public_path__ + "static/design_components-aa3555ebf649f542feab38cd6661e874.svg";